import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { SurveyService } from '../rest_services/msSurveyServices/survey.service';
import { VisitService } from '../rest_services/visit.service';

@Component({
  selector: 'app-satisfaction-survey',
  templateUrl: './satisfaction-survey.component.html',
  styleUrls: ['./satisfaction-survey.component.css']
})
export class SatisfactionSurveyComponent implements OnInit {

  uuid:any;
  surveyResponse!: FormGroup;
  laoding: boolean= true;
  laodingSending: boolean= false;
  requestBody = {};

  constructor(
    private formBuilder: FormBuilder,
    private visitService:VisitService,
    private route : ActivatedRoute,
    private msSurvey : SurveyService
    ) { 
      if (window.location.href.indexOf("satisfaction-survey") > -1) {        
        this.removeLink("assets/css/landing/cloud-bundle.min.css");
      }
  }
  private removeLink(link: string) {
    var linksToRemove = [];
    var linksTags = document.getElementsByTagName('link');
    
    for (var i = linksTags.length - 1; i >= 0; i--) {
        if (linksTags[i].href.indexOf(link) > -1 && linksTags[i].href.indexOf("cloud-bundle.min.css") > -1 && linksTags[i].rel === 'stylesheet') {
            linksToRemove.push(linksTags[i]);
        }
    }

    // Remove the marked links from the head
    linksToRemove.forEach(link => {
        document.head.removeChild(link);
    });
  }




  ngOnInit(): void {
    this.uuid = this.route.snapshot.params['id']; 
    this.getSurvey();
    // this.surveyResponse = this.formBuilder.group({
    //   rating: [''],
    //   option: ['oui'],
    //   comment: ['']
    // });
  }
  sanitizeInput(event: any): void {
    const initialValue: string = event.target.value;
    const sanitizedValue: string = initialValue.replace(/[^\w\s!@#$%^&*()_+[\]{}|;:'",.<>?`~\-=/]/g, '');
    if (initialValue !== sanitizedValue) {
      this.surveyResponse.patchValue({ comment: sanitizedValue }, { emitEvent: false });
      event.preventDefault();
    }
  }
  sendSurveyResponse() {
    this.laodingSending= true;
    const responses :any[] = [];
    // Iterate through each question and construct the response object
    this.questions.forEach((question, index)  => {
        let response = {
            qst_uuid: question.qst_uuid,
            response: ''
        };

        if (question.type === 'st') {
          response.response = this.surveyResponse.get('rating' + index)?.value;
      } else if (question.type === 'ch') {
          response.response = this.surveyResponse.get('option' + index)?.value;
      } else if (question.type === 'fr') {
          response.response = this.surveyResponse.get('comment' + index)?.value;
      }


        responses.push(response);
    });

    // Construct the requestBody object
    this.requestBody = {
      survey_visit_uuid : this.uuid,
      resp : responses
    };
    
    this.msSurvey.sendResponse(this.requestBody);
    this.msSurvey.sendResponseSubject.subscribe(
      ( data: any ) => {
        this.laodingSending= false;
        if(data.message =="Response to Survey visit sent successfully"){
          (<any>$("#staticBackdrop")).modal('show');
        }else{
          (<any>$("#error")).modal('show');
        }
      },
      (error: any) => {
      }
    )
}

  questions:any[]= [];
  visitUuid:any;
  getSurvey(){
    this.msSurvey.getSurveyForClient(this.uuid);
    this.msSurvey.surveyClientSubject.subscribe(
      ( data: any ) => {
        if(data.status== '200'){
          if(data.survey.surveyStatus == "responded"){
            (<any>$("#error")).modal('show');
          }
          this.laoding= false;
          this.questions = data.survey.questions;
          this.visitUuid = data.survey.visitUuid;
          this.getCustomerRSByVisitUuid(this.visitUuid);
          // Initialize form controls dynamically based on question types
          this.surveyResponse = this.formBuilder.group({});
          this.questions.forEach((question, index) => {
              if (question.type === 'st') {
                  this.surveyResponse.addControl('rating' + index, this.formBuilder.control(''));
              } else if (question.type === 'ch') {
                  this.surveyResponse.addControl('option' + index, this.formBuilder.control('oui'));
              } else if (question.type === 'fr') {
                  this.surveyResponse.addControl('comment' + index, this.formBuilder.control(''));
              }
          });
        }
      },
    )    
  }
  customerRs:any='';
  logo:any=null;
  getCustomerRSByVisitUuid(id:any){
    this.visitService.getCustomerByVisit(id, ['id', 'customer', 'logo']);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.customerRs = data.visit.visit_customer;
          this.logo = data.visit.visit_customer_logo;
        }
      },
    )  
  }


}
